import { Component, forwardRef, ViewChild } from '@angular/core';
import { CAMPAIGN_TYPE  } from 'app/virtual-event/virtual-event.enums';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

let id = 1;
@Component({
  selector: 'app-actions-popover-survey',
  templateUrl: './actions-popover-survey.component.html',
  styleUrls: ['./actions-popover-survey.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ActionsPopoverSurveyComponent),
    multi: true,
  }]
})
export class ActionsPopoverSurveyComponent implements ControlValueAccessor {
  
  @ViewChild('popover') popover: MdbPopoverDirective = null;

  public takeUntilSubject = new Subject();

  private _id = id++;
  get id() {
    return `ActionsPopoverSurvey_${this._id}`;
  }

  public CAMPAIGN_TYPE = CAMPAIGN_TYPE;
  public isProduction = false;

  constructor(
    private popoverService: PopoverService,
  ) { 
      this.isProduction = window['isProduction'];
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  postponedForWeek(): void {
    this.onChangeCallback(0);
  }

  postponedForMonth(): void {
    this.onChangeCallback(1);
  }

  postponedForever(): void {
    this.onChangeCallback(2);
  }

  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};

  registerOnChange(fn: any) { 
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }

  writeValue(value: string) {
  }

}
